import { EntityHistoryQuery } from 'graphql/EntityHistory/queries/EntityHistoryQuery';
import { Fragment, React, useQuery } from 'libs/react';
import { Text } from 'components/Text';
import { Table } from './table/Table';
import { DateTime } from './DateTime';
import './EntityHistory.scss';
/**
 * @component EntityHistory
 * @since 1.0.0
 */
export function EntityHistory(props) {
    const { entity, entityId, changesToShow, showChanges } = props;
    const [data, ready] = useQuery(EntityHistoryQuery, {
        variables: {
            input: {
                entity: entity,
                entityId: entityId
            }
        },
        fetchPolicy: 'network-only'
    });
    let values = data === null || data === void 0 ? void 0 : data.history;
    const columns = [];
    columns.push({
        column: 'description',
        header: t('Description'),
        footer: t('Description'),
        render: (value) => {
            var _a, _b;
            return (React.createElement(Fragment, null,
                React.createElement(Text, { className: "table-row-title", value: (_b = (_a = EventTag[entity]) === null || _a === void 0 ? void 0 : _a[value.event]) !== null && _b !== void 0 ? _b : value.event })));
        }
    });
    columns.push({
        column: 'user',
        header: t('User'),
        footer: t('User'),
        render: (value) => {
            var _a, _b;
            return (React.createElement(Fragment, null,
                React.createElement(Text, { className: "table-row-title", value: ((_a = value.user) === null || _a === void 0 ? void 0 : _a.fullname) ? (_b = value.user) === null || _b === void 0 ? void 0 : _b.fullname : t('Public') })));
        }
    });
    if (showChanges) {
        columns.push({
            column: 'changes',
            header: t('Information'),
            footer: t('Information'),
            render: (value) => {
                let changes = '';
                const after = value.changes ? JSON.parse(value.changes.after) : {};
                if (changesToShow && changesToShow[value.event]) {
                    const keysString = changesToShow[value.event];
                    const keys = keysString.split(',').map((k) => k.trim());
                    const changeParts = [];
                    keys.forEach((key) => {
                        if (after[key] !== undefined && after[key] !== null) {
                            changeParts.push(String(after[key]));
                        }
                    });
                    changes = changeParts.join(' | ');
                }
                return (React.createElement(Fragment, null,
                    React.createElement(Text, { className: "table-row-title", value: changes })));
            }
        });
    }
    columns.push({
        column: 'createdAt',
        type: 'date',
        width: '15%',
        align: 'right',
        header: t('Date'),
        footer: t('Date'),
        render: (value) => {
            return (React.createElement(Fragment, null,
                React.createElement(DateTime, { className: "table-row-date", value: value.createdAt, y: "numeric", m: "numeric", d: "numeric", time: true })));
        }
    });
    const schema = {};
    columns.forEach((column, index) => {
        schema['c' + (index + 1)] = column;
    });
    if (values == null) {
        values = [];
    }
    const emptyMessagePicto = 'fal clock-rotate-left';
    const emptyMessageTitle = t(`This entity doesn't have any history yet.`);
    return (React.createElement(Table, { className: "entity-history-table", ready: ready, schema: schema, values: values, sortable: [], defaultSortOrder: "desc", actionsColumn: "c3", emptyMessagePicto: emptyMessagePicto, emptyMessageTitle: emptyMessageTitle }));
}
const EventTag = {
    DEAL: {
        CREATED: t('Quote created'),
        UPDATED: t('Quote updated'),
        APPROVED: t('Quote approved'),
        ACCEPTED: t('Quote accepted'),
        PUBLISHED: t('Quote published'),
        SENT: t('Quote sent'),
        ORDERED: t('Quote converted to order'),
        DISCOUNT_APPLIED: t('Discount applied'),
        NEW_VERSION: t('New version'),
        QUOTE_OPENED: t('Quote opened'),
        ASSIGNED: t('Quote assigned'),
        REASSIGNED: t('Quote reassigned'),
        MEWS_ROUNDING: t('Mews rounding adjustment'),
        CANCELLED: t('Order cancelled'),
        REFUNDED: t('Payment refunded'),
        REFUND_FAILED: t('Refund failed')
    },
    CONTACT: {
        CREATED: t('Contact created'),
        UPDATED: t('Contact updated'),
        DELETED: t('Contact deleted')
    },
    CLIENT: {
        CREATED: t('Client created'),
        UPDATED: t('Client updated'),
        DELETED: t('Client deleted')
    },
    SALE_ITEM: {
        CREATED: t('Product created'),
        CREATED_FROM_COPY: t('Product created from copy'),
        UPDATED: t('Product updated'),
        DELETED: t('Product deleted'),
        PRICE_CHANGE: t('Price changed')
    },
    SALE_ITEM_GROUP: {
        CREATED: t('Category created'),
        UPDATED: t('Category updated'),
        DELETED: t('Category deleted')
    },
    SALE_ITEM_VARIANT: {
        CREATED: t('Variant created'),
        UPDATED: t('Variant updated'),
        DELETED: t('Variant deleted'),
        PRICE_CHANGE: t('Price changed')
    },
    SALE_ITEM_PACKAGE: {
        CREATED: t('Package created'),
        UPDATED: t('Package updated'),
        DELETED: t('Package deleted')
    },
    USER: {
        CREATED: t('User created'),
        UPDATED: t('User updated'),
        DELETED: t('User deleted'),
        PASSWORD_RESET: t('Password reset')
    },
    ORDER: {
        CREATED: t('Order created'),
        UPDATED: t('Order updated'),
        DELETED: t('Order deleted'),
        CANCELLED: t('Order cancelled')
    },
    NEWS: {
        CREATED: t('Article created'),
        UPDATED: t('Article updated'),
        DELETED: t('Article deleted')
    },
    VOUCHER: {
        CREATED: t('Voucher created'),
        UPDATED: t('Voucher updated'),
        DELETED: t('Voucher deleted'),
        REDEEMED: t('Voucher used'),
        VOIDED: t('Voucher voided'),
        RESTORED: t('Voucher reactivated'),
        SENT: t('Voucher sent')
    }
};
